import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { UserOutlined } from "@ant-design/icons";
import { DatePicker, Select, Space, Spin } from "antd";
import {
  RepeatSendIcon,
  SaveIcon,
  SaveTemplateIcon,
  SendIcon,
  SendLaterIcon,
} from "assets/icons";
import { SEND_MESSAGE } from "constants";
import { BROADCAST_TYPE } from "constants";
import { PATTERNS } from "constants/appConstant";
import dayjs from "dayjs";
import { getIn, useFormik } from "formik";
import parsePhoneNumber from "libphonenumber-js";
import moment from "moment/moment";
import { AuthInfo } from "stores/slices/auth";
import { doCreateBroadcast, doGetListAddress } from "stores/slices/broadcast";
import { doGetBroadcastListPage } from "stores/slices/broadcastList";
import { doGetCustomerPageSearchKeyAll } from "stores/slices/customer";
// import { doGetAllBroadcastList } from "stores/slices/broadcastList";
// import { doGetAllCustomers } from "stores/slices/customer";
import { setHeaderTitle } from "stores/slices/layout";
import {
  doGetAllMessageTemplate,
  fetchAllMessageTemplate,
} from "stores/slices/messageTemplate";
import { doGetAddressDetail } from "stores/slices/numbers";
import { doGetUserInfo } from "stores/slices/user";
import { getWorkspaceInfo } from "stores/slices/workspace";
import { renderAnnually, renderWeeklyLabel } from "utils";
import * as Yup from "yup";

import BulkSMSCreditBalance from "components/bulkSMSCreditBalance";
import ButtonDropdown from "components/button/buttonDropdown";
import FormInput from "components/forms/components/formInput";
import ModalForm from "components/forms/components/modalForm";

import MessageTemplateForm from "../message/messageTemplateForm";

import CustomRepeatForm from "./CustomRepeatForm";
import TagRecipient from "./tagRecipient";

import styles from "./styles.module.scss";

const url =
  "https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg";

const BroadcastSendMessage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const authInfo = useSelector(AuthInfo);

  const listMessageTemplate = useSelector(fetchAllMessageTemplate);

  const [listAddress, setListAddress] = useState([]);
  const [totalAddressPages, setTotalAddressPages] = useState(0);
  const [optionsMessageTemplate, setOptionsMessageTemplate] = useState([]);
  const [optionsRecipients, setOptionsRecipients] = useState([]);
  const [optionsAddress, setOptionsAddress] = useState([]);

  const [isOpenSelectTimeLater, setIsOpenSelectTimeLater] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpenCustom, setIsOpenCustom] = useState(false);
  const [isOpenForm, setIsOpenForm] = useState(false);
  const [loadingList, setLoadingList] = useState(false);
  const [sendType, setSendType] = useState(BROADCAST_TYPE.SEND_NOW);
  const [timeLater, setTimeLater] = useState();
  const [timeRepeat, setTimeRepeat] = useState(false);
  const [repeatType, setRepeatType] = useState();
  const [showErrorMessage, setShowErrorMessage] = useState("");
  const [customBroadcast, setCustomBroadcast] = useState();
  const [numberRepeat, setNumberRepeat] = useState(1);
  const [selectedRepeatType, setSelectedRepeatType] = useState("DAY");
  const [endDateType, setEndDateType] = useState("NONE");
  const [amountEndDate, setAmountEndDate] = useState(1);
  const [customEndDate, setCustomEndDate] = useState();
  const [customListWeek, setCustomListWeek] = useState([]);
  const [listTimezone, setListTimezone] = useState([]);
  const [selectedTimezone, setSelectedTimezone] = useState();
  const [customDayMonth, setCustomDayMonth] = useState();
  const [customDateYear, setCustomDateYear] = useState();
  const [showErrorMessageYear, setShowErrorMessageYear] = useState("");
  const [showErrorMessageEndDate, setShowErrorMessageEndDate] = useState("");
  const [apiKey, setApiKey] = useState("");

  const [isWorkspaceTimezone, setIsWorkspaceTimezone] = useState(false);
  const workspaceInfo = useSelector(state => state.workspace.workspaceDetail);
  const userDetail = useSelector(state => state.user.userDetail);
  const { customer } = userDetail;

  const [listAllBroadcastList, setListAllBroadcastList] = useState([]);
  const [totalBroadcastListPages, setTotalBroadcastListPages] = useState(0);
  const [broadcastListQueries, setBroadcastListQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
  });
  const [broadcastListOption, setOptionBroadcastList] = useState([]);

  const [listAllCustomer, setListAllCustomer] = useState([]);
  const [totalCustomerPages, setTotalCustomerPages] = useState(0);
  const [customerListQueries, setCustomerListQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
  });
  const [customerOption, setOptionCustomer] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectedRecipients, setSelectedRecipients] = useState([]);

  const [selectedBroadcastLists, setSelectedBroadcastLists] = useState([]);
  const [addressQueries, setAddressQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
  });
  const [loadingAddress, setLoadingAddress] = useState(false);

  useEffect(() => {
    dispatch(setHeaderTitle("broadcast"));
    dispatch(doGetAllMessageTemplate({ workspaceId: authInfo.workspaceId }));
    fetchListAddress({
      pageNumber: 1,
      pageSize: 10,
      workspaceId: authInfo.workspaceId,
    });
    dispatch(getWorkspaceInfo(authInfo.workspaceId));
    dispatch(doGetUserInfo(authInfo.id));
    const timeZoneList = moment.tz.names().map(item => {
      return {
        value: item,
        label: item,
      };
    });
    setListTimezone(timeZoneList);
    setSelectedCustomers([]);
    setSelectedRecipients([]);
    setSelectedBroadcastLists([]);
  }, []);

  useEffect(() => {
    if (listAddress && listAddress.length > 0) {
      const options = listAddress.map(item => {
        return {
          id: item.id,
          name: item.address,
        };
      });
      setOptionsAddress(options);
    }
  }, [listAddress]);

  const fetchListAddress = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
    };
    if (request.workspaceId) {
      newRequest["workspaceId"] = request.workspaceId;
    }
    if (request.isReset) {
      setListAddress([]);
      setOptionsAddress([]);
      delete newRequest.isReset;
    }
    if (totalAddressPages > 0 && totalAddressPages < newRequest.pageNumber) {
      return;
    }
    setLoadingAddress(true);
    const { payload } = await dispatch(doGetListAddress(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListAddress(removeDuplicates([...payload.content]));
      } else {
        setListAddress(removeDuplicates([...listAddress, ...payload.content]));
      }
      setTotalAddressPages(payload.totalPages);
      setAddressQueries(newRequest);
    }
    setLoadingAddress(false);
  };

  const handleScrollAddress = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      addressQueries.pageNumber <= totalAddressPages &&
      !loadingList
    ) {
      fetchListAddress({
        ...addressQueries,
        pageNumber: addressQueries.pageNumber + 1,
      });
    }
  };

  const handleSearchKeyAddress = key => {
    if (key) {
      fetchListAddress({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        address: key,
      });
    } else {
      fetchListAddress({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
      });
    }
  };

  useEffect(() => {
    if (workspaceInfo && userDetail) {
      const { workspaceSetting } = workspaceInfo;
      const { customer } = userDetail;
      if (
        workspaceSetting &&
        workspaceSetting.timeZone &&
        workspaceSetting.scheduleTimeZone
      ) {
        setIsWorkspaceTimezone(true);
        setSelectedTimezone(workspaceSetting.timeZone);
      } else if (customer && customer.timeZone) {
        setSelectedTimezone(customer.timeZone);
      } else {
        setSelectedTimezone(moment.tz.guess());
      }
    }
  }, [workspaceInfo, userDetail]);

  useEffect(() => {
    if (listMessageTemplate && listMessageTemplate.length > 0) {
      const options = listMessageTemplate.map(item => {
        return {
          id: item.id,
          name: item.title,
        };
      });
      setOptionsMessageTemplate(options);
    }
  }, [listMessageTemplate]);

  const defaultImageCustomer = () => <UserOutlined />;

  useEffect(() => {
    handleGetOptions({
      pageNumber: 1,
      pageSize: 10,
    });
  }, []);

  const removeDuplicates = (arr, isCustomer) => {
    if (isCustomer) {
      return arr.filter(
        (ele, ind) =>
          ind === arr.findIndex(elem => elem.customerId === ele.customerId)
      );
    } else {
      return arr.filter(
        (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
      );
    }
  };

  const fetchListBroadcastList = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      statuses: ["ACTIVE"],
    };
    if (request.workspaceId) {
      newRequest["workspaceId"] = request.workspaceId;
    }
    if (request.isReset) {
      setListAllBroadcastList([]);
      setOptionBroadcastList([...selectedBroadcastLists]);
      delete newRequest.isReset;
    }
    if (
      totalBroadcastListPages > 0 &&
      totalBroadcastListPages < newRequest.pageNumber
    ) {
      return;
    }
    setLoadingList(true);
    const { payload } = await dispatch(doGetBroadcastListPage(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListAllBroadcastList(removeDuplicates([...payload.content]));
      } else {
        setListAllBroadcastList(
          removeDuplicates([...listAllBroadcastList, ...payload.content])
        );
      }
      setTotalBroadcastListPages(payload.totalPages);
      setBroadcastListQueries(newRequest);
    } else {
      setListAllBroadcastList([]);
    }
    setLoadingList(false);
  };

  const fetchListCustomer = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
    };
    delete newRequest.setTotalElement;
    if (request.workspaceId) {
      newRequest["workspaceId"] = request.workspaceId;
    }
    if (request.isReset) {
      setListAllCustomer([]);
      setOptionCustomer([...selectedCustomers]);
      delete newRequest.isReset;
    }
    if (totalCustomerPages > 0 && totalCustomerPages < newRequest.pageNumber) {
      return;
    }
    setLoadingList(true);
    const { payload } = await dispatch(
      doGetCustomerPageSearchKeyAll(newRequest)
    );
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListAllCustomer(removeDuplicates([...payload.content], true));
      } else {
        setListAllCustomer(
          removeDuplicates([...listAllCustomer, ...payload.content], true)
        );
      }
      setTotalCustomerPages(payload.totalPages);
      setCustomerListQueries(newRequest);
    } else {
      setListAllCustomer([]);
    }
    setLoadingList(false);
  };

  const handleGetOptions = async request => {
    const broadcastListRequest = {
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
    };
    const customerListRequest = {
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      setTotalElement: true,
    };
    fetchListBroadcastList(broadcastListRequest);
    fetchListCustomer(customerListRequest);
  };

  useEffect(() => {
    if (listAllBroadcastList && listAllBroadcastList?.length > 0) {
      const newOptions = listAllBroadcastList.map(item => {
        return {
          id: item.id,
          label: item.name,
          phone: item.numberOfCustomer,
          src: url,
          broadcastList: true,
        };
      });
      setOptionBroadcastList(newOptions);
    } else {
      setOptionBroadcastList([]);
    }
    if (listAllCustomer && listAllCustomer?.length > 0) {
      const newOptions = listAllCustomer.map(item => {
        let label = "";
        if (item.firstName && item.lastName) {
          label = `${item.firstName} ${item.lastName}`;
        } else {
          label = "Unknown";
        }
        if (item.firstName && !item.lastName) {
          label = `${item.firstName} `;
        }
        if (item.lastName && !item.firstName) {
          label = `${item.lastName} `;
        }
        const avatar =
          item.profileImage &&
          item.profileImage !== "null" &&
          item.profileImage !== "" &&
          (item.profileImage.includes(".png") ||
            item.profileImage.includes(".jpg") ||
            item.profileImage.includes(".jpeg"))
            ? `${item.profileImage}`
            : defaultImageCustomer;
        return {
          id: item.contact.phoneNumber,
          label: label,
          phone: item.contact.phoneNumber,
          src: avatar,
        };
      });
      setOptionCustomer(
        removeDuplicates([...selectedCustomers, ...newOptions])
      );
    } else {
      setOptionCustomer([...selectedCustomers]);
    }
  }, [listAllBroadcastList, listAllCustomer]);

  useEffect(() => {
    if (selectedRecipients && selectedRecipients.length > 0) {
      setOptionsRecipients(
        removeDuplicates([
          ...selectedRecipients,
          ...broadcastListOption,
          ...customerOption,
        ])
      );
    } else {
      setOptionsRecipients(
        removeDuplicates([...broadcastListOption, ...customerOption])
      );
    }
  }, [broadcastListOption, customerOption, selectedRecipients]);

  const handleScroll = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      broadcastListQueries.pageNumber <= totalBroadcastListPages &&
      !loadingList
    ) {
      fetchListBroadcastList({
        ...broadcastListQueries,
        pageNumber: broadcastListQueries.pageNumber + 1,
      });
    }
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      customerListQueries.pageNumber <= totalCustomerPages &&
      !loadingList
    ) {
      fetchListCustomer({
        ...customerListQueries,
        pageNumber: customerListQueries.pageNumber + 1,
      });
    }
  };

  const handleSearchKey = key => {
    if (key) {
      fetchListBroadcastList({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        searchKeyName: key,
      });
      fetchListCustomer({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        searchKeyAll: key,
      });
    } else {
      fetchListBroadcastList({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
      });
      fetchListCustomer({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
      });
    }
  };

  const onSubmit = async data => {
    setLoading(true);
    let recipients = [];
    let broadcastListIds = [];

    data.recipients.map(rc => {
      if (selectedCustomers.find(cus => cus.id === rc)) {
        const customer = selectedCustomers.find(cus => cus.id === rc);
        recipients.push(customer.phone.toString().replaceAll(" ", ""));
      }
      if (selectedBroadcastLists.find(br => br.id === rc)) {
        broadcastListIds.push(rc);
      }
    });
    const request = {
      recipients: recipients,
      broadcastListIds: broadcastListIds,
      serviceId: data.senderNumber,
      broadcastType: sendType,
      message: data.message,
      timezone: selectedTimezone
        .replaceAll("0", "")
        .replaceAll("1", "")
        .replaceAll("2", ""),
    };
    if (timeLater && sendType === BROADCAST_TYPE.SEND_LATER) {
      request.sendLaterTime = moment
        .utc(timeLater)
        .format("MM/DD/YYYY HH:mm:00");
    }
    if (customBroadcast && sendType === BROADCAST_TYPE.REPEAT) {
      request.customBroadcast = customBroadcast;
    }
    const result = await dispatch(doCreateBroadcast(request));
    if (result.payload.status === 200) {
      if (sendType === BROADCAST_TYPE.SEND_LATER) {
        setTimeLater();
      }
      if (sendType === BROADCAST_TYPE.REPEAT) {
        resetCustom();
      }

      setSelectedTimezone(
        isWorkspaceTimezone
          ? workspaceInfo?.workspaceSetting?.timeZone
          : userDetail?.timeZone
          ? userDetail?.timeZone
          : moment.tz.guess()
      );
      resetForm();
    } else {
      setEndDateType("NONE");
    }
    setLoading(false);
  };

  const handleSendType = async type => {
    setLoading(true);
    let recipients = [];
    let broadcastListIds = [];
    values.recipients.map(rc => {
      if (selectedCustomers.find(cus => cus.id === rc)) {
        const customer = selectedCustomers.find(cus => cus.id === rc);
        recipients.push(customer.phone);
      }
      if (selectedBroadcastLists.find(br => br.id === rc)) {
        broadcastListIds.push(rc);
      }
    });
    const request = {
      recipients: recipients,
      broadcastListIds: broadcastListIds,
      serviceId: values.senderNumber,
      broadcastType: type,
      message: values.message,
    };
    const result = await dispatch(doCreateBroadcast(request));
    if (result.payload.status === 200) {
      resetForm();
    }
    setLoading(false);
  };

  const handleSelectOptionSend = data => {
    switch (data.key) {
      case "sendNow":
        setSendType(BROADCAST_TYPE.SEND_NOW);
        handleSubmit(values);
        break;
      case "sendLater":
        setSendType(BROADCAST_TYPE.SEND_LATER);
        setIsOpenSelectTimeLater(true);
        break;
      case "saveAsDraft":
        setSendType(BROADCAST_TYPE.DRAFT);
        handleSubmit(values);
        break;
      case "repeatSend":
        setSendType(BROADCAST_TYPE.REPEAT);
        handleSendType(BROADCAST_TYPE.REPEAT);
        break;
      case "saveAsTemplate":
        setIsOpenForm(true);
        break;
      case "DAILY":
      case "WEEKLY_ON":
      case "EVERY_WEEKDAY":
      case "YEARLY_ON":
      case "CUSTOM":
        setIsOpenCustom(true);
        setSendType(BROADCAST_TYPE.REPEAT);
        setRepeatType(data.key);
        setSelectedTimezone(
          isWorkspaceTimezone
            ? workspaceInfo?.workspaceSetting?.timeZone
            : userDetail?.customer?.timeZone
            ? userDetail?.customer?.timeZone
            : moment.tz.guess()
        );
        break;
    }
  };

  const validationSchema = Yup.object().shape({
    senderNumber: Yup.string().required("validate.required"),
    message: Yup.string()
      .required("validate.required")
      .matches(PATTERNS.XSS_PATTERN, "validate.noxss"),
    recipients: Yup.array().test("recipients", "validate.required", arr => {
      if (arr.length === 0) {
        return false;
      } else {
        return true;
      }
    }),
  });

  const handleForm = useFormik({
    initialValues: {
      recipients: [],
      senderNumber: "",
      message: "",
      template: "Select Your Template",
    },
    validationSchema: validationSchema,
    onSubmit: onSubmit,
  });
  const { values, resetForm, setFieldValue, handleSubmit } = handleForm;

  const inputTemplate = [
    {
      type: "select",
      key: "template",
      options: optionsMessageTemplate,
      style: {
        minWidth: 100,
      },
    },
  ];
  const checkValidPhoneNumber = (phone, showError, response) => {
    let phoneNumber = phone;
    if (
      PATTERNS.PHONE_NUMBER_LENGTH.test(phone) &&
      PATTERNS.ZERO_ONLY.test(phone)
    ) {
      const validPhoneNumber = parsePhoneNumber(phoneNumber);
      if (validPhoneNumber && validPhoneNumber.isPossible()) {
        if (validPhoneNumber.country && validPhoneNumber.isValid()) {
          const newValue = validPhoneNumber.formatInternational();
          if (response) {
            return newValue.replaceAll(" ", "").replaceAll("+", "");
          } else {
            return true;
          }
        }
      } else {
        phoneNumber = phone.includes("+") ? phone : `+${phoneNumber}`;
        const validContactNumber = parsePhoneNumber(phoneNumber);
        if (validContactNumber && validContactNumber.isPossible()) {
          if (validContactNumber.country && validContactNumber.isValid()) {
            const newValue = validContactNumber.formatInternational();
            if (response) {
              return newValue.replaceAll(" ", "").replaceAll("+", "");
            } else {
              return true;
            }
          } else {
            showError && toast.error(t("validate.phoneNumber.invalid"));
            return false;
          }
        } else {
          const validPhoneNumber2 = parsePhoneNumber(phone, "AU");
          if (validPhoneNumber2 && validPhoneNumber2.isPossible()) {
            if (validPhoneNumber2.country && validPhoneNumber2.isValid()) {
              const newValue = validPhoneNumber2.formatInternational();
              if (response) {
                return newValue.replaceAll(" ", "").replaceAll("+", "");
              } else {
                return true;
              }
            } else {
              showError && toast.error(t("validate.phoneNumber.invalid"));
              return false;
            }
          } else {
            const validContactNumber2 = parsePhoneNumber(phoneNumber, "AU");
            if (validContactNumber2 && validContactNumber2.isPossible()) {
              if (
                validContactNumber2.country &&
                validContactNumber2.isValid()
              ) {
                const newValue = validContactNumber2.formatInternational();
                if (response) {
                  return newValue.replaceAll(" ", "").replaceAll("+", "");
                } else {
                  return true;
                }
              } else {
                showError && toast.error(t("validate.phoneNumber.invalid"));
                return false;
              }
            }
          }
        }
      }
    } else {
      showError && toast.error(t("validate.phoneNumber.invalid"));
      return false;
    }
  };

  const handleGetServiceDetail = async id => {
    const { payload } = await dispatch(doGetAddressDetail(id));
    if (payload && payload.status === 200) {
      if (payload?.data) {
        const { channel } = payload.data;
        setApiKey(channel && channel.apiKey);
      }
    }
  };

  const handleChange = (key, val) => {
    if (key === "senderNumber") {
      if (val === undefined) {
        setFieldValue("senderNumber", "");
        setApiKey("");
        fetchListAddress({
          pageNumber: 1,
          pageSize: 10,
          isReset: true,
        });
      } else {
        setFieldValue(key, val);
        handleGetServiceDetail(val);
      }
    }
    if (key === "template") {
      const option = listMessageTemplate.filter(opt => opt.id === val && opt);
      if (option.length > 0) {
        const newMessage = option[0].message;
        setFieldValue("message", newMessage);
      }
    }
    if (key === "message") {
      if (val === undefined) {
        setFieldValue("message", "");
      } else {
        setFieldValue(key, val);
      }
    }
    if (key === "recipients" && typeof val === "object" && val.length > 0) {
      console.log("recipients", val);
      const newListPhone = val.filter(
        item => checkValidPhoneNumber(item, false) && item
      );
      const listPhoneNumber = newListPhone.map(item => {
        if (!customerOption.find(customer => customer.id === item)) {
          return checkValidPhoneNumber(item, false, true);
        } else {
          return item;
        }
      });
      const listBroadcast = val.filter(
        item => !PATTERNS.INPUT_NUMBER.test(item)
      );
      let newList = [];
      listAllBroadcastList.map(br => {
        const isAdd = listBroadcast.findIndex(item => item === br.id);
        if (isAdd !== -1) {
          newList.push(listBroadcast[isAdd]);
        }
      });
      setFieldValue(key, [...listPhoneNumber, ...newList]);
      const selectedCustomer = customerOption
        .map(customer => {
          if (listPhoneNumber.find(item => item === customer.id)) {
            return customer;
          }
        })
        .filter(item => item !== undefined && item);
      setSelectedCustomers(
        removeDuplicates([...selectedCustomers, ...selectedCustomer])
      );
      const selectedBroadcastList = broadcastListOption
        .map(broadcastList => {
          if (listBroadcast.find(item => item === broadcastList.id)) {
            return broadcastList;
          }
        })
        .filter(item => item !== undefined && item);
      setSelectedBroadcastLists(
        removeDuplicates([...selectedBroadcastLists, ...selectedBroadcastList])
      );
      setSelectedRecipients(
        removeDuplicates([
          ...selectedRecipients,
          ...selectedBroadcastList,
          ...selectedCustomer,
        ])
      );
      fetchListBroadcastList({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
      });
      fetchListCustomer({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
      });
    } else {
      setFieldValue(key, val);
      // setSelectedRecipients(val);
    }

    if (key === "recipients" && typeof val === "object") {
      const newVal = val[val.length - 1];
      console.log("newVal", newVal);
      const checkListCustomers = optionsRecipients.filter(
        op => !op.broadcastList && op
      );
      if (
        !checkListCustomers.find(
          op => op.phone === newVal && op.id === newVal
        ) &&
        PATTERNS.PHONE_NUMBER_LENGTH.test(newVal)
      ) {
        const checkAddCustomer = checkValidPhoneNumber(newVal, true, true);
        if (checkAddCustomer) {
          const newOption = {
            id: checkAddCustomer,
            label: `${checkAddCustomer}`,
            phone: checkAddCustomer,
            src: defaultImageCustomer,
          };
          setOptionsRecipients(
            removeDuplicates([...optionsRecipients, newOption])
          );
          setOptionCustomer([...listAllCustomer, newOption]);
          setSelectedCustomers([...selectedCustomers, newOption]);
          setSelectedRecipients([...selectedRecipients, newOption]);
          fetchListBroadcastList({
            pageNumber: 1,
            pageSize: 10,
            isReset: true,
          });
          fetchListCustomer({
            pageNumber: 1,
            pageSize: 10,
            isReset: true,
          });
        }
      }
    }
  };

  const renderMessageHeader = () => {
    return (
      <div className={styles.messageHeader}>
        <p>{t("label.message")}</p>
        <FormInput
          items={inputTemplate.map(item => {
            item.label = t(item.label);
            if (item.key) {
              item.value = getIn(values, item.key);
            }
            return { ...item };
          })}
          form={handleForm}
          onChange={handleChange}
          layout={"vertical"}
        />
      </div>
    );
  };

  const onSendMessageLater = datePicker => {
    if (datePicker && datePicker.$d) {
      let newTime = datePicker.$d;
      const minutes = moment(datePicker.$d).minutes();
      const hours = moment(datePicker.$d).hours();

      if (minutes > 0 && minutes <= 5) {
        newTime = moment(datePicker.$d).minutes(5);
      } else if (minutes > 5 && minutes <= 10) {
        newTime = moment(datePicker.$d).minutes(10);
      } else if (minutes > 10 && minutes <= 15) {
        newTime = moment(datePicker.$d).minutes(15);
      } else if (minutes > 15 && minutes <= 20) {
        newTime = moment(datePicker.$d).minutes(20);
      } else if (minutes > 20 && minutes <= 25) {
        newTime = moment(datePicker.$d).minutes(25);
      } else if (minutes > 25 && minutes <= 30) {
        newTime = moment(datePicker.$d).minutes(30);
      } else if (minutes > 30 && minutes <= 35) {
        newTime = moment(datePicker.$d).minutes(35);
      } else if (minutes > 35 && minutes <= 40) {
        newTime = moment(datePicker.$d).minutes(40);
      } else if (minutes > 40 && minutes <= 45) {
        newTime = moment(datePicker.$d).minutes(45);
      } else if (minutes > 45 && minutes <= 50) {
        newTime = moment(datePicker.$d).minutes(50);
      } else if (minutes > 50 && minutes <= 55) {
        newTime = moment(datePicker.$d).minutes(55);
      } else if (minutes > 55 && minutes <= 59) {
        newTime = moment(datePicker.$d)
          .hours(hours + 1)
          .minutes(0);
      }
      setTimeLater(newTime);
      setShowErrorMessage("");
    } else {
      setTimeLater();
    }
  };

  const handleSendLater = () => {
    if (!timeLater) {
      setShowErrorMessage(t("validate.required"));
    } else {
      setShowErrorMessage("");
      setIsOpenSelectTimeLater(false);
      handleSubmit(values);
    }
  };

  const inputItems = [
    {
      type: "select-search",
      key: "senderNumber",
      label: "label.senderNumber",
      placeholder: "label.senderNumber",
      value: "",
      options: optionsAddress,
      config: {
        loading: loadingAddress,
        handleScroll: handleScrollAddress,
        handleSearchKey: handleSearchKeyAddress,
      },
    },
    {
      type: "tags-search",
      key: "recipients",
      label: "label.recipients",
      placeholder: "label.recipients",
      value: [],
      options: optionsRecipients,
      tagRender: TagRecipient,
      selectKeyValue: "id",
      config: {
        loading: loadingList,
        mode: "multiple",
        style: {
          height: "auto",
        },
        handleSearchKey: handleSearchKey,
        handleScroll: handleScroll,
      },
    },
    {
      type: "textarea",
      key: "message",
      label: "label.message",
      placeholder: "label.message",
      value: "",
      labelRender: renderMessageHeader,
      config: {
        showCount: true,
        maxLength: 5000,
      },
    },
  ];

  const sendMessageItems = [
    {
      key: SEND_MESSAGE.SEND_NOW,
      icon: <SendIcon />,
    },
    {
      key: SEND_MESSAGE.SEND_LATER,
      icon: <SendLaterIcon />,
    },
    {
      key: SEND_MESSAGE.SAVE_DRAFT,
      icon: <SaveIcon />,
    },
    {
      key: SEND_MESSAGE.SAVE_TEMPLATE,
      icon: <SaveTemplateIcon />,
    },
    {
      key: SEND_MESSAGE.REPEAT_SEND,
      icon: <RepeatSendIcon />,
      children: [
        {
          key: SEND_MESSAGE.REPEAT_DAILY,
          label: "Daily",
        },
        {
          key: SEND_MESSAGE.REPEAT_WEEKLY,
          label: renderWeeklyLabel(moment.utc().local().day()),
        },
        {
          key: SEND_MESSAGE.REPEAT_ANNUALY,
          label: renderAnnually(),
        },
        {
          key: SEND_MESSAGE.REPEAT_EVERY_WEEKDAY,
          label: "Every weekday (Monday to Friday)",
        },
        {
          key: SEND_MESSAGE.REPEAT_CUSTOM,
          label: "Custom...",
        },
      ],
    },
  ];

  const handleSetTimeRepeat = time => {
    if (time && time.$d) {
      let newTime = time.$d;
      setTimeRepeat(newTime);
      setShowErrorMessage("");
    } else {
      setTimeRepeat();
    }
  };

  const handleSendRepeat = () => {
    if (!customDateYear && selectedRepeatType === "YEAR") {
      setShowErrorMessageYear(t("validate.required"));
    } else {
      setShowErrorMessageYear("");
    }
    if (!customEndDate && endDateType === "ON") {
      setShowErrorMessageEndDate(t("validate.required"));
    } else {
      setShowErrorMessageEndDate("");
    }
    if (!timeRepeat) {
      setShowErrorMessage(t("validate.required"));
    } else {
      setShowErrorMessage("");
      const time = moment.utc(timeRepeat).format("HH:mm");
      const custom = {
        type: "CUSTOM",
        time: time,
      };
      if (
        customListWeek &&
        (repeatType === "EVERY_WEEKDAY" || selectedRepeatType === "WEEK")
      ) {
        custom.weekDays = customListWeek;
      }
      custom.customRepeatType = selectedRepeatType.replaceAll("S", "");
      custom.customRepeatAmount = numberRepeat;

      if (selectedRepeatType === "MONTH") {
        custom.customDayMonth = customDayMonth || 1;
      }
      if (selectedRepeatType === "YEAR") {
        if (!customDateYear) {
          setShowErrorMessageYear(t("validate.required"));
        } else {
          setShowErrorMessageYear();
          custom.date = moment(customDateYear.$d).format("MM/DD/YYYY");
        }
      }
      const customEndDateField = {
        endDateType: endDateType,
      };
      if (endDateType === "ON") {
        const newDate = moment(customEndDate.$d).format("MM/DD/YYYY");
        customEndDateField.endDate = newDate;
      }
      if (endDateType === "AFTER") {
        customEndDateField.amount = amountEndDate;
      }
      custom.customEndDate = customEndDateField;
      setIsOpenCustom(false);
      setCustomBroadcast(custom);
      handleSubmit(values);
      setTimeRepeat();
      setShowErrorMessage("");
    }
  };

  const resetCustom = () => {
    setCustomBroadcast();
    setTimeRepeat(false);
    setNumberRepeat(1);
    setSelectedRepeatType("DAY");
    setEndDateType("NONE");
    setAmountEndDate(1);
    setCustomEndDate();
    setCustomListWeek([]);
    setSelectedTimezone(
      isWorkspaceTimezone
        ? workspaceInfo?.workspaceSetting?.timeZone
        : userDetail?.customer?.timeZone
        ? userDetail?.customer?.timeZone
        : moment.tz.guess()
    );
    setCustomDayMonth();
    setCustomDateYear();
    setShowErrorMessage("");
    setShowErrorMessageYear("");
    setShowErrorMessageEndDate("");
  };
  const handleGetTimeSendLaterNow = () => {
    const minutues = moment().local().minutes();
    const hours = moment().local().hours();
    if (minutues > 0 && minutues <= 5) {
      setTimeLater(moment().local().minutes(5));
    } else if (minutues > 5 && minutues <= 10) {
      setTimeLater(moment().local().minutes(10));
    } else if (minutues > 10 && minutues <= 15) {
      setTimeLater(moment().local().minutes(15));
    } else if (minutues > 15 && minutues <= 20) {
      setTimeLater(moment().local().minutes(20));
    } else if (minutues > 20 && minutues <= 25) {
      setTimeLater(moment().local().minutes(25));
    } else if (minutues > 25 && minutues <= 30) {
      setTimeLater(moment().local().minutes(30));
    } else if (minutues > 30 && minutues <= 35) {
      setTimeLater(moment().local().minutes(35));
    } else if (minutues > 35 && minutues <= 40) {
      setTimeLater(moment().local().minutes(40));
    } else if (minutues > 40 && minutues <= 45) {
      setTimeLater(moment().local().minutes(45));
    } else if (minutues > 45 && minutues <= 50) {
      setTimeLater(moment().local().minutes(50));
    } else if (minutues > 50 && minutues <= 55) {
      setTimeLater(moment().local().minutes(55));
    } else if (minutues > 55 && minutues <= 59) {
      setTimeLater(
        moment()
          .local()
          .hours(hours + 1)
          .minutes(0)
      );
    }
  };
  const renderExtraFooter = () => (
    <div
      style={{ display: "flex", alignItems: "center" }}
      onClick={() => handleGetTimeSendLaterNow()}
    >
      <a>{t("label.now")}</a>
    </div>
  );

  // const handleFormatDateTimeLocale = () => {
  //   const browserLocale = navigator.language;
  //   let dateLocale;
  //   dateLocale = moment()
  //     .tz(customer?.timeZone ? customer?.timeZone : moment.tz.guess())
  //     .locale(browserLocale);
  //   return `${dateLocale.format("YYYY-MM-DD HH:mm")}`;
  // };

  return (
    <div className={styles.profilePage}>
      <div className={styles.profileContent}>
        {loading && (
          <Space
            size="middle"
            style={{
              width: "100%",
              height: 400,
              position: "absolute",
              zIndex: 1000,
              justifyContent: "center",
              maxWidth: "800px",
            }}
          >
            <Spin size="large" />
          </Space>
        )}
        {apiKey && <BulkSMSCreditBalance apiKey={apiKey} />}
        <Space
          direction="vertical"
          size="small"
          style={{
            display: "flex",
          }}
        >
          <FormInput
            items={inputItems.map(item => {
              item.label = t(item.label);
              if (item.key) {
                item.value = getIn(values, item.key);
              }
              return { ...item };
            })}
            form={handleForm}
            onChange={handleChange}
            layout={"vertical"}
          />
          <div className={styles.customButtonRight}>
            <div className={styles.buttonRight}>
              <ButtonDropdown
                color={"blue"}
                items={sendMessageItems}
                onButtonClick={() => {
                  setSendType(BROADCAST_TYPE.SEND_NOW);
                  handleSubmit(values);
                }}
                onMenuClick={handleSelectOptionSend}
                disabled={
                  loading || process.env.REACT_APP_ENVIRONMENT === "production"
                }
              />
            </div>
          </div>
        </Space>
      </div>
      <ModalForm
        title={t("title.customRecurrence")}
        isOpen={isOpenCustom}
        onCancel={() => {
          setIsOpenCustom(false);
          resetCustom();
        }}
        footer={false}
        destroyOnClose={true}
        customWidth={400}
        maskClosable={false}
      >
        <CustomRepeatForm
          setIsOpenCustom={setIsOpenCustom}
          onCancel={() => {
            setIsOpenCustom(false);
            resetCustom();
          }}
          onSubmit={() => handleSendRepeat()}
          loading={false}
          setTimeRepeat={setTimeRepeat}
          setNumberRepeat={setNumberRepeat}
          numberRepeat={numberRepeat}
          handleSetTimeRepeat={handleSetTimeRepeat}
          setSelectedRepeatType={setSelectedRepeatType}
          selectedRepeatType={selectedRepeatType}
          showErrorMessage={showErrorMessage}
          setEndDateType={setEndDateType}
          endDateType={endDateType}
          setAmountEndDate={setAmountEndDate}
          setCustomEndDate={setCustomEndDate}
          setCustomListWeek={setCustomListWeek}
          setSelectedTimezone={setSelectedTimezone}
          selectedTimezone={selectedTimezone}
          listTimezone={listTimezone}
          setCustomDayMonth={setCustomDayMonth}
          setCustomDateYear={setCustomDateYear}
          repeatType={repeatType}
          setRepeatType={setRepeatType}
          customDateYear={customDateYear}
          showErrorMessageYear={showErrorMessageYear}
          setShowErrorMessageYear={setShowErrorMessageYear}
          showErrorMessageEndDate={showErrorMessageEndDate}
          setShowErrorMessageEndDate={setShowErrorMessageEndDate}
          timeRepeat={timeRepeat}
          customEndDate={customEndDate}
          customer={customer}
        />
      </ModalForm>
      <ModalForm
        title={t("title.settingSendLater")}
        isOpen={isOpenSelectTimeLater}
        onCancel={() => {
          setIsOpenSelectTimeLater(false);
          setTimeLater();
        }}
        onSubmit={() => handleSendLater()}
        labelSubmit={t("button.send")}
        destroyOnClose={true}
        customWidth={350}
        maskClosable={false}
      >
        <div style={{ marginBottom: 8 }}>{t("label.DateAndTime")}</div>
        <DatePicker
          placeholder={t("text.selectDateAndTime")}
          format={"YYYY-MM-DD HH:mm"}
          showTime={{
            format: `HH:mm`,
          }}
          showNow={false}
          onChange={onSendMessageLater}
          needConfirm={false}
          changeOnScroll={true}
          value={timeLater && dayjs(timeLater)}
          disabledDate={currentDate => {
            if (moment(currentDate.$d).year() === moment(new Date()).year()) {
              if (moment(currentDate.$d).month() < moment(new Date()).month()) {
                return true;
              } else if (
                moment(currentDate.$d).month() === moment(new Date()).month() &&
                moment(currentDate.$d).date() < moment(new Date()).date()
              ) {
                return true;
              } else {
                return false;
              }
            } else if (
              moment(currentDate.$d).year() > moment(new Date()).year()
            ) {
              return false;
            } else {
              return false;
            }
          }}
          minuteStep={5}
          style={{
            marginBottom: 8,
            width: "100%",
            borderColor: showErrorMessage ? "red" : "",
          }}
          renderExtraFooter={renderExtraFooter}
          popupClassName={styles.datePickerPopUp}
        />
        {showErrorMessage && (
          <span style={{ color: "red" }}>{showErrorMessage}</span>
        )}
        <div style={{ marginBottom: 8 }}>{t("label.timezone")}</div>
        <Select
          style={{ marginBottom: 8, width: "100%" }}
          defaultValue={selectedTimezone}
          options={listTimezone}
          onChange={setSelectedTimezone}
          showSearch={true}
        />
      </ModalForm>
      <ModalForm
        title={t("messageTemplates.addNewPopupTitle")}
        isOpen={isOpenForm}
        onCancel={() => setIsOpenForm(false)}
        footer={false}
        destroyOnClose={true}
        labelSubmit={t("label.save")}
        maskClosable={false}
      >
        <MessageTemplateForm
          userType={authInfo.type}
          workspaceId={authInfo?.workspaceId}
          setLoadingList={setLoadingList}
          loadingList={loadingList}
          broadcastMessage={values.message}
          onCancel={() => {
            setIsOpenForm(false);
          }}
          onSuccess={() => {
            setIsOpenForm(false);
            dispatch(
              doGetAllMessageTemplate({ workspaceId: authInfo.workspaceId })
            );
          }}
        />
      </ModalForm>
    </div>
  );
};

export default BroadcastSendMessage;
